//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// @ is an alias to /src
import { required } from 'vuelidate/lib/validators'
export default {
  name: 'Home',
  data() {
    return {
      form: {
        username: '',
        password: '',
        vcode:''
      },
      loading4: false
    }
  },
  components: {
   required
  },
  mounted() {
  const cookies = this.$q.cookies.getAll()
  const token = this.$q.cookies.get('becbas_token')
  if (token != undefined) {
    this.$router.push('/home') 
  }
},
  validations: {
    form: {
      username: { required }
    }
  },
  methods: {
    simulateProgress(number) {
      console.log('submit')
      console.log(this.form);
      this.$v.form.$touch()
      if (this.$v.form.$error) {
        this.$q.notify('请检查资料是否输入完整')
        return
      }
      var that = this;
      // we set loading state
      this[`loading${number}`] = true
      var data = this.form;

      this.$axios({
        url: '/api/login',
        method: 'post',
        data: data
      })
        .then(res => {
          console.log(res.data)
          this[`loading${number}`] = false
          if (res.data.status == 0) {
              let token = res.data.data;
              that.$q.cookies.set('becbas_token', token,{expires:1})
            that.showSuccess()
            //this.$router.push('/home') 
            window.location.reload()
          }else{
            that.showError(res.data.errmsg)
          }
        })
        .catch(Error => {
          console.log(Error)
          this[`loading${number}`] = false
        })

    },
    showSuccess() {
      this.$q.notify({
        message: '提示',
        caption: '操作成功',
        color: 'secondary'
      })
    },
    showError(msg) {
      this.$q.dialog({
        title: '出错了',
        message: msg
      }).onOk(() => {
        // console.log('OK')
      }).onCancel(() => {
        // console.log('Cancel')
      }).onDismiss(() => {
        // console.log('I am triggered on both OK and Cancel')
      })
    }
  }
}
